/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
app.controller('passwordResetCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'AtlasNotification', 'NetworkService', '$interval', function($rootScope, $scope, $http, networkService, AtlasNotification, NetworkService, $interval) {
    $scope.gui = {};
    $scope.cuId = cuId;
    $scope.token = token;
    $scope.gui.state = 1; //1 = default; 2 = timer for redirect
    
    $scope.timerCount = 5;

    
   $scope.resetPassword = function() {
        var data = {
            newpassword: $scope.newpassword,
            cuId: $scope.cuId,
            token: $scope.token
            
        }
       NetworkService.callOperation("passwordresetapi", data, function(response){
           var state = response.get("state")
           console.log(state)
           if(state == "SUCCESS"){
               $scope.gui.state = 2;
               AtlasNotification.info("Dein Passwort wurde erfolgreich zurückgesetzt. Du kannst dich jetzt einloggen.")
               $interval(function(){
                   if($scope.timerCount>0){
                       $scope.timerCount -= 1;
                   }else{
                       window.location = "/";
                   }
                   
               },1000)
           }else{
               AtlasNotification.info("Ein unerwarteter Fehler ist aufgetreten. Bitte melde dich beim Support.")
           }
       })
    }

}])
